import { SaleTypeDTO } from "../DTO/saleTypeDTO";

export class SaleType{

    /*
    1	Creditor Owned
    2	Forfeiture Right Offering
    3	Mortgage Foreclosure
    4	Non Bank Owned
    5	Pre-Foreclosure
    6	Receivership
    7	Short Sale
    8	Tax Foreclosure
    9	Government Owned
    10  Other
    */

    public id!:number;
    public name!:string;
    public checklistItems?:ChecklistItem[];
    
    constructor(){
    }

    get displayName(){
        if(this.id==3 || this.id==8) return "Private Selling Officer";
        else return this.name;
    }

    public static mapToDTO(param:SaleType) : SaleTypeDTO{
        
        let dto = new SaleTypeDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            if(param.checklistItems) dto.checklistItems = JSON.stringify(param.checklistItems);
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:SaleTypeDTO) : SaleType
    {
        
        let obj = new SaleType();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            if(param.checklistItems?.trim().length) {
                obj.checklistItems = JSON.parse(param.checklistItems);
                obj.checklistItems!.sort((a,b)=>(a.seqNo - b.seqNo));
            }

        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}

export class ChecklistItem{
    public id!:number;
    public seqNo!:number;
    public displayName!:string;
}